<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="mapes">
    <ItemCommonDescription
      :data-card="dataCard"
      :data-values="dataValues"
      :has-destination="hasDestination"
      @reload-data-card="reloadDataCard"
    />
    <div class="file-details-block has-side-bars">
      <l-map
        v-if="layerType && layerType !== 'NaN'"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        style="height: 400px; z-index: 1;"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
        @mousemove="updateMousePos"
        @mouseout="closeMousePos"
      >
        <l-control-layers position="bottomleft" />
        <l-control-attribution position="bottomright" prefix="" />
        <l-control-zoom position="topright" />
        <l-control-scale position="bottomright" :imperial="false" :metric="true" />
        <l-control v-if="mousePosV" position="bottomright">
          <span>{{ $t('lat') + ': ' + lat + ', ' + $t('lng') + ': ' + lng }}</span>
        </l-control>
        <l-tile-layer
          key="XYZ Example"
          attribution="Ajuntament de Barcelona (Fora terme municipal: AMB, &copy; CARTO, &copy; OpenStreetMaps contributors)"
          :url="xyzurl"
          :name="$t('map_base')"
          :visible="true"
          layer-type="base"
          :tile-size="256"
        />
        <l-image-overlay
          :name="$t('map_no_base')"
          layer-type="base"
          :visible="false"
          url="/blank.png"
          :bounds="bounds"
        />
        <!--l-tile-layer
          v-if="layerType === 'WMTS'"
          :url="wmtsServiceUrl + wmtsAdditions"
          layer-type="overlay"
          name="WMTS Example"
          :visible="true"
        /> -->
        <l-wms-tile-layer
          v-if="layerType === 'WMTS' && dataValues.layers"
          :base-url="dataValues.serviceUrl"
          attribution="Ajuntament de Barcelona (Fora terme municipal: AMB, &copy; CARTO, &copy; OpenStreetMaps contributors)"
          :layers="dataValues.layers"
          format="image/png"
          :transparent="true"
          :visible="true"
          :name="dataCard.title"
          layer-type="overlay"
        />
        <l-wms-tile-layer
          v-else-if="layerType === 'WMS'"
          :base-url="dataValues.serviceUrl"
          attribution="Ajuntament de Barcelona (Fora terme municipal: AMB, &copy; CARTO, &copy; OpenStreetMaps contributors)"
          :layers="dataValues.layers"
          format="image/png"
          :transparent="true"
          :visible="true"
          :name="dataCard.title"
          layer-type="overlay"
        />
        <l-control v-else position="topright">
          <div style="display: flex; justify-content: center; width: 100vw; margin-top: 30px;">
            <span style="font-size: 18px; background-color: white; padding: 0 15px;">{{ $t('service_unsupported') }}</span>
          </div>
        </l-control>
        <!--l-control v-if="dataValues.serviceUrl.substring(0, 5) !== 'https'" position="topright">
          <div style="display: flex; justify-content: center; width: 100vw; margin-top: 30px;">
            <span style="font-size: 18px; background-color: white; padding: 0 15px;">{{ $t('service_http') }}</span>
          </div>
        </!l-control-->
      </l-map>
      <span v-else class="not-prev-label">{{ $t('no_map_preview') }}</span>
    </div>
    <ItemViews :views="dataCard.popularity" />
    <ItemsRelated :card-id="dataCard.id" />
  </div>
</template>

<script>
import { latLng } from 'leaflet'
import ItemCommonDescription from './ItemCommonDescription.vue'
import ItemViews from './ItemViews'
import ItemsRelated from './ItemsRelated'
import {
  LMap,
  LTileLayer,
  LImageOverlay,
  LWMSTileLayer,
  LControlLayers,
  LControlZoom,
  LControl,
  LControlAttribution,
  LControlScale,
} from 'vue2-leaflet'
//import 'proj4leaflet'

// const customCrs = new L.Proj.CRS(
//   'EPSG:25831',
//   '+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs',
//   {
//     resolutions: [4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8],
//     //resolution = ScaleDenominator * PixelWidth (0.00028)
//     //ScaleDenominator = [279541131.975446, 139770565.987723, 69885282.9938616, 34942641.5039063, 17471320.7449777, 8735660.37388393, 4367830.18694196
//     //  2183915.09347098, 1091957.54673549, 545978.7734375, 272989.38671875, 136494.693345424, 68247.3466796875, 34123.6733398437, 17061.8366629464, 8530.91833426339,
//     //  4265.4591671317, 2132.7295828683, 1066.36479171317, 533.182395926339, 266.59119796317, 133.295598967634],
//     // resolutions: [
//     //   78271.51, 39135.75, 19567.87, 9783.93, 4891.96, 2445.98, 1222.99, 611.49, 305.74, 152.87,
//     //   76.43, 38.21, 19.1, 9.55, 4.77, 2.38, 1.19, 0.59, 0.29, 0.149, 0.074, 0.037,
//     // ],
//     origin: [420431.49, 4573683.01],
//     bounds: L.bounds([
//       [420431.49, 4573683.01],
//       [436060.16, 4591624.84],
//     ]),
//   }
// )

/**
 * Map view disposition
 * @example [none]
 */
export default {
  name: 'MapItem',
  components: {
    ItemCommonDescription,
    ItemViews,
    ItemsRelated,
    LMap,
    LTileLayer,
    LImageOverlay,
    LControlLayers,
    LControlZoom,
    LControl,
    LControlAttribution,
    LControlScale,
    'l-wms-tile-layer': LWMSTileLayer,
  },
  props: {
    /**
     * Item object information getted by api
     */
    dataCard: {
      type: Object,
    },
    dataValues: {
      type: Object,
    },
  },
  data() {
    return {
      lat: 0,
      lng: 0,
      mousePosV: false,
      bounds: [latLng(40.390167, 1.1733408), latLng(42.390167, 3.1733408)],
      xyzurl: 'https://cdn-geo.bcn.cat/XYZ/PLANOLBCN/{z}/{x}/{y}.png',
      center: latLng(41.390167, 2.1733408),
      mapOptions: {
        zoomSnap: 0.5,
        minZoom: 11.5,
        zoomControl: false,
        attributionControl: false,
        scrollWheelZoom: false,
      },
      wmtsServiceUrl: 'http://w133.bcn.cat/WMTSURBANISME/service.svc/get',
      wmtsAdditions:
        '?layer=Urbanisme&style=Default&tilematrixset=Urbanisme_3857&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fpng&TileMatrix={z}&TileCol={x}&TileRow={y}',
    }
  },
  computed: {
    zoom() {
      return this.dataValues?.defaultScale3857 || 12
    },
    layerType() {
      return this.dataValues?.serviceType || null
    },
    hasDestination() {
      return this.dataValues?.destinationUrl || null
    },
  },
  methods: {
    reloadDataCard() {
      this.$emit('reload-data-card')
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom
    },
    centerUpdate(center) {
      this.currentCenter = center
    },
    updateMousePos(event) {
      this.mousePosV = true
      this.lat = Math.round(event.latlng.lat * 100000) / 100000
      this.lng = Math.round(event.latlng.lng * 100000) / 100000
    },
    closeMousePos() {
      this.mousePosV = false
    },
  },
}
</script>

<style lang="stylus" scoped>
.mapes
  display: flex
  flex-direction: column
  width: 100%
  gap: vw(10px)

  .file-details-block
    display: flex
    justify-content: center
    align-items: center
    width: 100%

    .not-prev-label
      m-font-size(18, 22)
      margin-top: vw(40px)
      font-weight: 400
</style>
